/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserProfilePrivateRequest } from './UserProfilePrivateRequest';
import {
    UserProfilePrivateRequestFromJSON,
    UserProfilePrivateRequestFromJSONTyped,
    UserProfilePrivateRequestToJSON,
} from './UserProfilePrivateRequest';

/**
 * 
 * @export
 * @interface UserPrivateRequest
 */
export interface UserPrivateRequest {
    /**
     * 
     * @type {UserProfilePrivateRequest}
     * @memberof UserPrivateRequest
     */
    profile?: UserProfilePrivateRequest;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateRequest
     */
    last_name: string;
}

/**
 * Check if a given object implements the UserPrivateRequest interface.
 */
export function instanceOfUserPrivateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;

    return isInstance;
}

export function UserPrivateRequestFromJSON(json: any): UserPrivateRequest {
    return UserPrivateRequestFromJSONTyped(json, false);
}

export function UserPrivateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPrivateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile': !exists(json, 'profile') ? undefined : UserProfilePrivateRequestFromJSON(json['profile']),
        'email': json['email'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function UserPrivateRequestToJSON(value?: UserPrivateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile': UserProfilePrivateRequestToJSON(value.profile),
        'email': value.email,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

